import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const updateUserProfileService = async (data) => {
  const response = await axios.post('/update-user', data);
  return response.data;
};

export const getUserProfileDataService = createAsyncThunk(
  'userInfo/getUserProfileDataService',
  async () => {
    const response = await axios.get('/me');
    return response.data?.data;
  },
);
